import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "@scuf/common/honeywell/theme.css";
import "@scuf/datatable/honeywell/theme.css";
import { Provider } from "react-redux";
import { store } from "stores/GlobalStore";
import "./index.scss";

const container = document.getElementById("root");
// @ts-ignore
const root = createRoot(container);

// Here we are importing our stores file and spreading it across this Provider. All stores added to this will be accessible via child injects
root.render(
  <Provider store={store}>
    <App />
  </Provider>
  //document.getElementById("root")
);
